
<template v-if="billingDynamicStructure[billingLocale]">
    <div class="form-legend" v-html="`*${$t('label.required')}`"></div>
    <DynamicFields :FieldsStructure="billingDynamicStructure[billingLocale]" :FormName="'billing'" />
</template>

<script setup>
import DynamicFields from "@/components/checkout/DynamicFields";
import { mapGetters } from "@/store/helper/vuex";

const { billingDynamicStructure, billingLocale } = mapGetters();
</script>